import { Injectable, inject } from '@angular/core';
import {
  MachineTaskSettings,
  MachineTaskSettingsApi,
  machineTaskSettingsDefaults,
  machineTaskColumnsBaseConfig,
} from './machine-task-settings.api';
import { SettingsServiceBase } from 'src/services';
import { MachineTask } from './machine-tasks.model';
import { configToSettingsColumnTitles } from '../config-utils';

@Injectable()
export class MachineTaskSettingsService extends SettingsServiceBase<
  keyof MachineTask,
  MachineTaskSettings,
  MachineTaskSettingsApi
> {
  constructor() {
    const settingsApi = inject(MachineTaskSettingsApi);

    super(
      settingsApi,
      configToSettingsColumnTitles(machineTaskColumnsBaseConfig),
      machineTaskSettingsDefaults
    );
  }
}
